import { sajuProfile } from '../lib/profile.js';

// 한난(추움↔따뜻함)·조습(습함↔건조함) 막대. 점수는 -100~100, 가운데가 중간.
function Gauge({ title, axis, kind }) {
  const pos = Math.min(100, Math.max(0, (axis.score + 100) / 2));
  return (
    <div className={`gauge ${kind}`}>
      <b className="gname">{title}</b>
      <span className="gend">{axis.low}</span>
      <div className="gtrack" role="img" aria-label={`${axis.low}과 ${axis.high} 사이, ${axis.label}`}>
        <i className="gmid" />
        <i className="gdot" style={{ left: `${pos}%` }} />
      </div>
      <span className="gend">{axis.high}</span>
      <span className="glabel">{axis.label}</span>
    </div>
  );
}

export default function ClimateGauge({ saju }) {
  const climate = sajuProfile(saju)?.climate;
  if (!climate) return null;
  return (
    <section className="climate">
      <h3>한난 · 조습</h3>
      <Gauge title="한난" axis={climate.warm} kind="warm" />
      <Gauge title="조습" axis={climate.dry} kind="dry" />
      <p className="climate-traits-caption">게임에서는 다음과 같은 성향으로 표현합니다.</p>
      <dl className="climate-traits">
        <div><dt>따뜻한 사주</dt><dd>감정과 생각을 드러내는 편입니다. 사람을 만나거나 새로운 일을 시작하는 데 적극적입니다.</dd></div>
        <div><dt>차가운 사주</dt><dd>차분하게 상황을 살피는 편입니다. 바로 반응하기보다 충분히 생각한 뒤 움직입니다.</dd></div>
        <div><dt>습한 사주</dt><dd>주변 분위기와 감정에 민감한 편입니다. 관계를 고려하고 상황에 맞춰 유연하게 대응합니다.</dd></div>
        <div><dt>건조한 사주</dt><dd>자신의 기준과 경계를 분명히 하는 편입니다. 스스로 판단하고 결정한 일을 밀고 나갑니다.</dd></div>
      </dl>
      <details className="climate-method"><summary>계산 기준</summary><p className="muted">
        한난은 사주가 춥고 따뜻한 정도, 조습은 젖어 있고 말라 있는 정도예요.
        글자마다 값을 주고 자리별로 합한 게임용 추정이에요. 태어난 달의 글자를 가장 크게 봐요.
        {!climate.hourIncluded && ' 태어난 시간을 몰라서 여섯 글자로 계산했어요.'}
      </p></details>
    </section>
  );
}
